export const ALL_PROMOS = 'ALL_PROMOS'
export const ALL_PROMOS_LABEL = 'plp.promo_all_filter'
export const EARLY_ACCESS = 'EARLY_ACCESS'
export const FLASH_SALE = 'FLASH_SALE'
export const FLASH_SALE_LABEL = 'flash sale'
export const GREEN_LABEL = '-Green'
export const NONE = 'none'
export const PROMO_TIMER_TICK = 1000
export const PST_LABEL = 'PST'
export const PST = 'pst'
export const EA = 'EA'
export const FLASH = 'flash'
export const PST_PROMOS = 'PST_PROMOS'
export const RED_LABEL = '-Red'
export const SANITIZED_PRICE_REGEXP = /\D*/
export const SCARCITY = 'scarcity'
export const SCARCITY_PROMO = 'SCARCITY_PROMO'
export const YELLOW_LABEL = '-Yellow'
export const CDT = 'CDT'
export const CST = 'CST'
export const PROMOCODE = 'promoCode'
export const FACET_KEY_PROMO_LABEL = 'plp.filters.facets.PROMO.label'
